export default function slick() {
  
  function init() {
    $("#slider").slick({
      dots: true,
      autoplay: true,
      pauseOnHover:false,
      autoplaySpeed: 6000,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  $( document ).ready(function() {
    if($('#slider').length > 0) {
      init();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/slider-slick.js